<template>
      <div class="sch">
        <input type="text" id="symbolName" name="symbolName" placeholder="종목 검색" v-model="$store.state.usRecordSettings.syName">
        <input type="hidden" id="symbol" name="symbol" autocomplete="off">
        <button @click="goSearch">검색</button>
      </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import { EventBus } from '@/store/event-bus'

export default {
  data () {
    return {
      items: []
    }
  },
  methods: {
    goSearch () {
      if ($('#symbolName').val() === '') {
        alert('종목명 또는 종목코드를 입력해주세요')
        $('#symbolName').focus()
      }
    }
  },
  mounted () {
    $('#symbolName').autocomplete({
      autoFocus: true,
      source: function (request, response) {
        const params = {
          pCode: request.term
        }
        let postUrl = 'https://security.thinkpool.com/api/us/symbolAjax.do'
        axios.post(postUrl, params).then((res) => {
          response($.map(res.data.resObj.stockList, function (item) {
            return {
              label: item.nameAndSymbol,
              value: item.name,
              key: item.symbol
            }
          }))
        })
      },
      minLength: 1,
      focus: function (event, ui) {
        return false
      },
      select: function (event, ui) {
        $('#symbolCode').val(ui.item ? ui.item.key : '')
        global.vm.$store.dispatch('saveUsSymbolSetting', ui.item.key)
        global.vm.$store.dispatch('saveUsSyNameSetting', ui.item.value)
        global.vm.$store.dispatch('saveUsChkIndexSetting', 'SYMBOL')
        EventBus.$emit('pageNo', 1)
      }
    }).data('ui-autocomplete')._renderItem = function (ul, item) {
      let $node = $('<div></div>').text(item.label)
      let searchText = $.trim(this.term).toLowerCase()
      let currentNode = $node.get(0).firstChild
      let matchIndex
      let newTextNode
      let newSpanNode
      let newEmNode

      let m1
      let new1
      let cur1
      let itemValue = item.value

      if ((m1 = currentNode.data.indexOf(itemValue)) >= 0) {
        new1 = currentNode.splitText(m1)
        cur1 = new1.splitText(itemValue.length)

        newEmNode = document.createElement('em')
        currentNode.parentNode.insertBefore(newEmNode, cur1)
        newEmNode.appendChild(new1)
      }

      while ((matchIndex = currentNode.data.toLowerCase().indexOf(searchText)) >= 0) {
        newTextNode = currentNode.splitText(matchIndex)
        currentNode = newTextNode.splitText(searchText.length)
        newSpanNode = document.createElement('span')
        newSpanNode.className = 'highlight'
        currentNode.parentNode.insertBefore(newSpanNode, currentNode)
        newSpanNode.appendChild(newTextNode)
      }

      return $('<li></li>').append($node).appendTo(ul)
    }
  },
  computed: {
    ...mapGetters(['getUsRecordSettings']),
    getChkSymbol () {
      return this.getUsRecordSettings.symbol
    },
    getChkIndex () {
      return this.getUsRecordSettings.chkIndex
    }
  },
  watch: {
    getChkIndex (val, oldVal) {
      if (val !== oldVal) {
        if (val !== 'SYMBOL') {
          $('#symbolName').val('')
          $('#symbolCode').val('')
        }
      }
    }
  }
}
</script>

<style scoped>
  .ui-autocomplete {
    width: 300px;
  }

  .ui-widget.ui-widget-content {
    max-height: 8.261rem;
    box-sizing: border-box;
    padding: 0.543rem 1.304rem;
    border-radius: 1.304rem;
    background: #f3f3f3;
    overflow-y: auto;
  }

  .ui-menu-item {
    display: inline-block;
    width: 100%;
    padding: 0.5rem 0;
    font-size: 0.913rem;
    color: #333;
    border-bottom: 1px solid #282828;
    font-weight: 400;
  }
  .ui-menu .ui-menu-item-wrapper:hover, .ui-menu .ui-menu-item-wrapper:focus {
    background:#dadff1;
    color: #333;
  }
  .ui-autocomplete .highlight { color:#ed3e4b }
  .ui-menu-item:last-child {
    border-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/kiwoom/usRecord/pc/common/Search.vue